import moment from 'moment';
import padStart from 'lodash/padStart';
import * as ResourceApi from 'api/resources';
import * as ServiceApi from 'api/services';
import FilterOperator from 'classes/FilterOperators';
import {filterOptionsFactory, sortOptionsFactory} from 'viewOptions/factories';
import {zeroPad} from 'utils/DBUtils';
import {isNoU} from "../utils/DBUtils";

const emptySorts = sortOptionsFactory();
const emptyFilters = filterOptionsFactory();

export const getBestSellingItems = lang => ResourceApi.getPage(
  ResourceApi.Types.BestSellingStoreItem,
  5,
  1,
  emptySorts,
  filterOptionsFactory({
    filters: [
      {
        field: 'lang',
        value: lang
      }
    ]
  })
);

export const createStoreEscrow = (lang, year, month, budget, copy) => ResourceApi.create(
  ResourceApi.Types.StoreEscrow,
  {
    lang,
    year,
    month,
    budget,
    copy
  },
  []
);

export const getStoreAccount = siteId => ResourceApi.getPage(
  ResourceApi.Types.StoreAccount,
  1, // there can only be one
  1,
  emptySorts,
  filterOptionsFactory({
    filters: [
      {
        field: 'siteId',
        value: siteId
      }
    ]
  })
);

// deprecated. use getRetailersByNgcEndpoint()
export const getRetailers = storeAccountId => ResourceApi.getPage(
  ResourceApi.Types.Retailer,
  100, // just an arbitrarily high number, likely much smaller in reality.
  1,
  emptySorts,
  filterOptionsFactory({
    filters: [
      {
        field: 'account_id',
        value: storeAccountId
      },
      {
        field: 'ind_active',
        value: 1
      },
    ]
  })
);

export const getRetailersByNgcEndpoint = ngcEndpointId => ResourceApi.getPage(
  ResourceApi.Types.Retailer,
  100, // just an arbitrarily high number, likely much smaller in reality.
  1,
  emptySorts,
  filterOptionsFactory({
    filters: [
      {
        field: 'ngc_api_id',
        value: ngcEndpointId
      },
      {
        field: 'ind_active',
        value: 1
      },
    ]
  })
);


export const getStoreEscrows = (storeAccountId, year, month) => {
    let monthCount = 12; // total possible months in a year
    let startMonthStr = "01";
    let endMonthStr = "12";
    let args = {
        calculatebalance: false
    };

    if (!isNoU(month)) {
        monthCount = 1;
        startMonthStr = padStart(`${month}`, 2, "0");
        endMonthStr = startMonthStr;
        args = null;
    }

    let startDate = `${year}-${startMonthStr}-01`;
    let endDate = `${year}-${endMonthStr}-31`;

    console.log(storeAccountId, year, month);
    console.log(startDate, endDate);

    return ResourceApi.getPage(
        ResourceApi.Types.StoreEscrow,
        monthCount,
        1,
        emptySorts,
        filterOptionsFactory({
            filters: [
                {
                    field: 'start_date',
                    operator: FilterOperator.GreaterThanOrEqual,
                    value: startDate
                },
                {
                    field: 'start_date',
                    operator: FilterOperator.LessThan,
                    value: endDate
                },
                {
                    field: 'account_id',
                    value: storeAccountId
                }
            ]
        }),
        args
    );
};

// this assumes that the month being passed is moment-compatible, so zero-indexed.
export const getStoreOrders = (retailerItemId, year, month, numPerPage, currentPage) => {
  const requestedYear = year ? moment().year(year) : moment().year();

  // any single-digit date fragments must be zero-padded for date filters.
  const numberToGet = numPerPage || 20;
  const page = currentPage || 1;

  const firstDayOfMonth = zeroPad(requestedYear.month(month).date(1).date(), 2);
  const lastDayOfMonth = requestedYear.month(month + 1).date(0).date();

  // increment month number for API call
  const monthString = zeroPad(month + 1, 2);

  const startDate = `${year}-${monthString}-${firstDayOfMonth}`;
  const endDate = `${year}-${monthString}-${lastDayOfMonth}`;

  return ResourceApi.getPage(
    ResourceApi.Types.StoreOrder,
    numberToGet,
    page,
    emptySorts,
    filterOptionsFactory({
      filters: [
        {
          field: 'retailer_item_id',
          value: retailerItemId
        },
        {
          field: 'purchased',
          operator: FilterOperator.GreaterThanOrEqual,
          value: startDate
        },
        {
          field: 'purchased',
          operator: FilterOperator.LessThanOrEqual,
          value: endDate
        }
      ]
    })
  );
};

export const resendOrderEmail = orderId => ServiceApi.performAction(
  ResourceApi.Types.StoreOrder,
  ServiceApi.Actions.ResendOrder,
  {orderId}
);

// for use in LiveMode (current month)
export const increaseStock = (lang, escrowId, retailerItemId, totalItems) => ServiceApi.performAction(
  ResourceApi.Types.StoreStock,
  ServiceApi.Actions.AddStock,
  {
    lang,
    escrowId,
    retailerItemId,
    totalItems
  }
);

export const decreaseStock = (lang, escrowId, retailerItemId, totalItems) => ServiceApi.performAction(
  ResourceApi.Types.StoreStock,
  ServiceApi.Actions.RemoveStock,
  {
    lang,
    escrowId,
    retailerItemId,
    totalItems
  }
);

// for use in PlanningMode (future months)
export const updateQuantity = (lang, escrowId, retailerItemId, totalItems) => ServiceApi.performAction(
  ResourceApi.Types.StoreStock,
  ServiceApi.Actions.StockStore,
  {
    lang,
    escrowId,
    retailerItemId,
    totalItems
  }
);

export const exportStoreData = (lang, escrowId) => ResourceApi.download(
  ResourceApi.Types.StoreCatalog,
  {
    lang,
    escrowId
  }
);

export const createRetailerItem = (lang, formData) => ResourceApi.create(
  ResourceApi.Types.RetailerItem,
  {...formData, lang},
  []
);

export const updateRetailerItem = (lang, retailerItemId, changes, resourceId) => ResourceApi.saveChangelist(
  ResourceApi.Types.RetailerItem,
  retailerItemId,
  changes,
  [resourceId],
  {lang}
);

export const deleteRetailerItem = (lang, retailerItemId) => ResourceApi.deleteResource(
  ResourceApi.Types.RetailerItem,
  retailerItemId,
  [],
  {lang}
);



// WEBPACK FOOTER //
// ./public/api/rewards-store.js